export const getHMFromShortTimeString = (time) => {
    const [hours, minutes] = time.split(':');
    return [Number(hours), Number(minutes)];
};
export const setHMToDate = (date, hours, minutes) => {
    const newDate = new Date(date);
    newDate.setHours(Number(hours), Number(minutes), 0, 0);
    return newDate;
};
export const getDateWithUTCTime = (utcString) => {
    const utcDate = new Date(utcString);
    const localDateWithUTCTime = new Date();
    localDateWithUTCTime.setFullYear(utcDate.getUTCFullYear(), utcDate.getUTCMonth(), utcDate.getUTCDate());
    localDateWithUTCTime.setHours(utcDate.getUTCHours(), utcDate.getUTCMinutes(), utcDate.getUTCSeconds(), utcDate.getUTCMilliseconds());
    return localDateWithUTCTime;
};
//# sourceMappingURL=utils.js.map